;(function () {
  'use strict'

  angular.module('contrast.license').factory('LicenseFactory', LicenseFactory)

  function LicenseFactory($http, UserService) {
    'ngInject'

    return {
      //Assessment
      getAssessmentBreakdown: getAssessmentBreakdown,
      applyLicense: applyLicense,
      getUpcomingAssessmentExpiredLicenses:
        getUpcomingAssessmentExpiredLicenses,

      //Protection
      getProtectionBreakdown: getProtectionBreakdown,
      getUpcomingProtectionExpiredLicenses:
        getUpcomingProtectionExpiredLicenses,
      getProtectUsageHistory: getProtectUsageHistory,
      getProtectUsageHistoryOldestDate: getProtectUsageHistoryOldestDate,
      applyProtectionLicense: applyProtectionLicense
    }

    //Assessment
    function getAssessmentBreakdown() {
      return $http.get(UserService.buildAPIUrl('/licenses'))
    }

    function applyLicense(appId, level) {
      return $http.post(UserService.buildAPIUrl('/licenses/' + appId), {
        level: level
      })
    }

    function getUpcomingAssessmentExpiredLicenses() {
      return $http.get(
        UserService.buildAPIUrl('/licenses/applications/nearexpiration')
      )
    }

    //Protection
    function getProtectionBreakdown() {
      return $http.get(UserService.buildAPIUrl('/rasp/licenses'))
    }

    function getUpcomingProtectionExpiredLicenses() {
      return $http.get(
        UserService.buildAPIUrl('/rasp/licenses/servers/nearexpiration')
      )
    }

    function getProtectUsageHistoryOldestDate(startDate) {
      return $http.get(
        UserService.buildAPIUrl('/rasp/licenses/usage/timeframe'),
        {
          params: {
            startDate: startDate
          }
        }
      )
    }

    function getProtectUsageHistory(startDate, endDate) {
      return $http.get(UserService.buildAPIUrl('/rasp/licenses/usage'), {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      })
    }

    function applyProtectionLicense(serverId) {
      return $http.put(UserService.buildAPIUrl('/rasp/licenses/' + serverId))
    }
  }
})()
